import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_11022_21848)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = ["fill"]
const _hoisted_5 = ["fill"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11022_21848" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'categoryWeighting',
  props: {
  color: {
    type: String as PropType<string>,
    default: "currentColor",
  },
  width: {
    type: Number as PropType<number>,
    default: 14,
  },
  height: {
    type: Number as PropType<number>,
    default: 14,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("path", {
        d: "M10.75 3.99805C10.8163 3.99805 10.8799 3.97171 10.9268 3.92482C10.9737 3.87794 11 3.81435 11 3.74805V0.998047C11 0.73283 10.8946 0.478476 10.7071 0.29094C10.5196 0.103404 10.2652 -0.00195312 10 -0.00195312L2 -0.00195312C1.73478 -0.00195312 1.48043 0.103404 1.29289 0.29094C1.10536 0.478476 1 0.73283 1 0.998047V3.74805C1 3.81435 1.02634 3.87794 1.07322 3.92482C1.12011 3.97171 1.1837 3.99805 1.25 3.99805H10.75ZM7.13 2.40805L7.045 2.65805C7.01146 2.75736 6.94755 2.84361 6.86231 2.90463C6.77708 2.96564 6.67482 2.99832 6.57 2.99805H5.43C5.32518 2.99832 5.22292 2.96564 5.13769 2.90463C5.05245 2.84361 4.98854 2.75736 4.955 2.65805L4.875 2.40805C4.8495 2.33324 4.84209 2.25345 4.85339 2.17523C4.86469 2.09701 4.89437 2.02258 4.94 1.95805C4.98601 1.89343 5.04673 1.84068 5.11715 1.80416C5.18758 1.76765 5.26567 1.74841 5.345 1.74805H6.655C6.73433 1.74841 6.81242 1.76765 6.88285 1.80416C6.95327 1.84068 7.01399 1.89343 7.06 1.95805C7.10646 2.02215 7.13704 2.09638 7.14921 2.17461C7.16138 2.25285 7.15479 2.33285 7.13 2.40805Z",
        fill: __props.color
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M10.75 7.74805C10.8163 7.74805 10.8799 7.72171 10.9268 7.67482C10.9737 7.62794 11 7.56435 11 7.49805V4.74805C11 4.68174 10.9737 4.61815 10.9268 4.57127C10.8799 4.52439 10.8163 4.49805 10.75 4.49805H1.25C1.1837 4.49805 1.12011 4.52439 1.07322 4.57127C1.02634 4.61815 1 4.68174 1 4.74805V7.49805C1 7.56435 1.02634 7.62794 1.07322 7.67482C1.12011 7.72171 1.1837 7.74805 1.25 7.74805H10.75ZM4.94 5.70805C4.98601 5.64343 5.04673 5.59068 5.11715 5.55416C5.18758 5.51765 5.26567 5.49841 5.345 5.49805H6.655C6.73433 5.49841 6.81242 5.51765 6.88285 5.55416C6.95327 5.59068 7.01399 5.64343 7.06 5.70805C7.10646 5.77215 7.13704 5.84638 7.14921 5.92461C7.16138 6.00285 7.15479 6.08285 7.13 6.15805L7.045 6.40805C7.01146 6.50736 6.94755 6.59361 6.86231 6.65463C6.77708 6.71564 6.67482 6.74832 6.57 6.74805H5.43C5.32518 6.74832 5.22292 6.71564 5.13769 6.65463C5.05245 6.59361 4.98854 6.50736 4.955 6.40805L4.875 6.15805C4.8495 6.08324 4.84209 6.00345 4.85339 5.92523C4.86469 5.84701 4.89437 5.77258 4.94 5.70805Z",
        fill: __props.color
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M1.25 8.24805C1.1837 8.24805 1.12011 8.27439 1.07322 8.32127C1.02634 8.36815 1 8.43174 1 8.49805V10.998C1 11.2633 1.10536 11.5176 1.29289 11.7052C1.48043 11.8927 1.73478 11.998 2 11.998H10C10.2652 11.998 10.5196 11.8927 10.7071 11.7052C10.8946 11.5176 11 11.2633 11 10.998V8.49805C11 8.43174 10.9737 8.36815 10.9268 8.32127C10.8799 8.27439 10.8163 8.24805 10.75 8.24805H1.25ZM4.94 9.45805C4.98601 9.39343 5.04673 9.34068 5.11715 9.30416C5.18758 9.26765 5.26567 9.24841 5.345 9.24805H6.655C6.73433 9.24841 6.81242 9.26765 6.88285 9.30416C6.95327 9.34068 7.01399 9.39343 7.06 9.45805C7.10646 9.52215 7.13704 9.59638 7.14921 9.67461C7.16138 9.75285 7.15479 9.83285 7.13 9.90805L7.045 10.158C7.01146 10.2574 6.94755 10.3436 6.86231 10.4046C6.77708 10.4656 6.67482 10.4983 6.57 10.498H5.43C5.32518 10.4983 5.22292 10.4656 5.13769 10.4046C5.05245 10.3436 4.98854 10.2574 4.955 10.158L4.875 9.90805C4.8495 9.83324 4.84209 9.75345 4.85339 9.67523C4.86469 9.59701 4.89437 9.52258 4.94 9.45805Z",
        fill: __props.color
      }, null, 8, _hoisted_5)
    ]),
    _hoisted_6
  ], 8, _hoisted_1))
}
}

})